export default __webpack_public_path__ + "static/media/bg-lower-right-corner.7e71f5a8.svg";